import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  selectionToggle,
  componentTreeSelectionChanged,
  componentTreeSelectionStartSelected,
  selectionStartSet,
  ComponentSelection,
  componentSelectionOperations,
} from '@ardoq/component-selection';
import { Observable } from 'rxjs';
// TODO use factory function to create selection streams
export const getSelectComponentHierarchySelection$ = (
  namespace: string
): Observable<ComponentSelection> =>
  reducedStream(
    'selectedComponentHierarchySelection$',
    {
      graphSelection: [],
      treeSelection: [],
      selectionStart: '',
    },
    [
      reducer(
        componentTreeSelectionStartSelected,
        componentSelectionOperations.componentTreeSelectionStartSelected
      ),
      reducer(
        componentTreeSelectionChanged,
        componentSelectionOperations.componentTreeSelectionChanged
      ),
      reducer(
        selectionStartSet,
        componentSelectionOperations.selectionStartSet
      ),
      reducer(
        selectionToggle,
        componentSelectionOperations.toggleTreeSelection
      ),
    ],
    { namespace }
  );
